<template>
    <div>
        <div
            v-for="(section, sectionIndex) in sections"
            :key="sectionIndex"
            style="margin-bottom: 30px; margin-top: 20px"
        >


            <div class="section-title animate" v-html="section.title">
                <!-- {{section.title}} -->
            </div>
            <div class="section-description animate" v-html="section.description">
            </div>
            <div class="animate" style="width: 100%; display: flex; justify-content: center; margin-top: 20px">
                <component v-if="section.component" :is="section.component" style="height: 300px" ></component>
                <img v-else-if="section.img" :src="section.img" alt="" style="max-width: 80vw; max-height: 400px; min-height: 200px; height: 400px">
                <iframe v-if="section.youtubeUrl" width="100%" style="min-height: 200px" :src="section.youtubeUrl"></iframe>
            </div>
        </div>
    </div>
</template>

<script>
import ClearancePic from "@/assets/images/versions/600/510kClearance.png";
import SharePic from "@/assets/images/versions/600/ShareProfile_Mockup.png";
import ImportPic from "@/assets/images/versions/600/ImportProfile_Mockup.png";
import ShareAndImportPic from "@/assets/images/versions/600/ShareAndImport_Mockup.png";
import CompatibleDevicePic from "@/assets/images/versions/600/CompatibleDevices.png";

import SitToStandAnimation from "@/components/Release520/SitToStandAnimation";

export default {
    name: "Release600Sections",
    components: {SitToStandAnimation},
    data() {
        return {
            sections: [
                {
                    title: '<div>510(k) Concussion Clearance</div>',
                    description: `<div><p>Sway Medical, Inc. Announces FDA 510(k) Clearance of its Comprehensive Concussion Management System. This clearance expands on Sway Medical’s previous FDA clearance for balance testing in head injuries, officially recognizing Sway as the first fully integrated tool that combines both cognitive and balance testing into one product for concussion management.</p></div>`,
                    // youtubeUrl: 'https://www.youtube.com/embed/rOECayR31fw',
	                img: ClearancePic
                    // component: SitToStandAnimation
                },
                {
                    title: '<div>Profile Sharing</div>',
                    description: `<div><p>Easily share or import profiles from one organization to another using the Share and Import tools in both the desktop portal and mobile app. 
                        
                    </p></div>`,
	                img: SharePic
                    // component: SitToStandAnimation
                },
                {
                    title: '<div>Import Profile</div>',
                    description: `<div><p>Easily import profiles from one organization from another using the Import Profile tool in both the desktop portal and mobile app. 
                        
                    </p></div>`,
                    img: ImportPic
                    // component: SitToStandAnimation
                },
                {
                    title: '<div>Compatible Device List Update</div>',
                    description: `<div><p>We have updated the list of compatible devices. <strong>Most notably, a few Android devices have been marked as unsupported due to unreliable hardware performance.</strong> Please ensure that you are using a compatible device to ensure the best experience with Sway.</p></div>`,
                    img: CompatibleDevicePic
                    // component: SitToStandAnimation
                },
                {
                    title: 'Other Updates',
                    description: `<div>
                    <ul>
                        <li><strong>Improved performance and reliability.</strong></li>
                        <li>Various bug fixes.</li>
                    </ul>
                    </div>`,
                },
            ]
        }
    }
}
</script>

<style scoped>
.section-title {
    font-weight: 900;
    margin: 20px 0;
    font-size: 16px;
    color: #333
}

.section-description {
    font-size: 14px;
    color: #757575
}
</style>